import React from "react";
import {
  FullScreen,
  WhiteBox,
  HeaderImgBlock,
  HeaderImg,
  TitleBlock,
  Title,
  DescriptionBlock,
  Description,
  ButtonBlock,
  Button,
  PointBlock,
  Point,
} from "./style";
import LottieLoader from "components/containers/common/LottieLoader";

export default function ImageModal({
  visible,
  dataList,
  lottieOptions,
  onComplete,
  zIndex,
}) {
  if (!visible || !dataList) return null;
  return (
    <FullScreen zIndex={zIndex}>
      <WhiteBox>
        {![null, undefined].includes(dataList["point"]) ? (
          <PointBlock>
            <Point>+{dataList.point}P</Point>
          </PointBlock>
        ) : null}
        <HeaderImgBlock>
          <HeaderImg src={dataList.modalImg} />
        </HeaderImgBlock>
        <TitleBlock>
          <Title>{dataList.title}</Title>
        </TitleBlock>
        <DescriptionBlock>
          <Description>{dataList.description}</Description>
        </DescriptionBlock>
        <ButtonBlock>
          <Button onClick={onComplete}>{dataList.buttonText}</Button>
        </ButtonBlock>
      </WhiteBox>
      {lottieOptions ? (
        <LottieLoader
          lottieOptions={lottieOptions}
          style={{ position: "absolute", top: "0" }}
        />
      ) : null}
    </FullScreen>
  );
}
